var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBackYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 22,
    viewBox: "0 0 10 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41495 21.1831L0.233057 11.6917C-0.0776854 11.3263 -0.0776854 10.7783 0.233057 10.4126L8.41495 0.815571C8.80132 0.42422 9.32405 0.392602 9.69905 0.744579C10.0911 1.11922 10.0854 1.72295 9.76724 2.09462L2.1308 10.9996L9.76724 19.9064C10.1012 20.2998 10.0718 20.9021 9.69974 21.2559C9.32405 21.6067 8.80132 21.5768 8.41495 21.1831Z",
    fill: "#DF992F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackYellow);
export default __webpack_public_path__ + "static/media/arrow-back-yellow.6955817a228962237ae36b1210d32c6c.svg";
export { ForwardRef as ReactComponent };